<template>
<div>
  <!--    信息-->
  <div class="info">
    <!--原创  显示ICON、作者-->
    <div v-if="isOriginal==1" class="originalIcon"></div>
    <!--非原创 出处、作者-->
    <div v-else class="original">{{original}}</div>

    <div class="original">{{author}}</div>
    <div class="originalDate">{{ showTime }}</div>
  </div>
</div>
</template>

<script>
export default {
  name: "shareOriginal",
  props:{
    isOriginal:{
      type: Number
    },
    original:{
      type: String
    },
    author:{
      type: String
    },
    showTime:{
      type: String
    }
  },
}
</script>

<style scoped>
.info{
  position: relative;
  margin-bottom: 40px;
  width: 990px;
  height: 50px;
  /*background-color: #ead287;*/
  font-size: 40px;
  color: #b7b7b7;
  line-height: 40px;
}
.info .originalIcon{
  margin-right: 40px;
  float: left;
  width: 80px;
  height: 40px;
  background-image: url("../../assets/app/original.jpg");
  background-size: 80px 40px;
}
.info .original{
  margin-right: 40px;
  float: left;
  color: #35303d;
}

.info .originalDate{
  margin-right: 40px;
  float: left;
  color: #b7b7b7;
}

</style>